<template>
  <div :class="getCss('copyright-container')"  v-if="showCopyRight" :style="copyrightContainerStyle" >
    <div :class="getCss('copy_wrap')">
      <div :class="getCss('copy_inner')">
        <p :class="getCss(['developer','copy_text_style'])">开发者：{{gameConfig.developer}}</p>
        <p :class="getCss(['developer','copy_text_style'])">运营者：{{gameConfig.carrier || gameConfig.developer }} </p>

      </div>
    </div>
    <div :class="getCss('copy_inner')">
      <span :class="getCss(['copy_game','copy_text_style'])">{{gameConfig.gameName}}{{gameConfig.version}}</span>
      <span :class="getCss('policy-area')" >
        <template v-if="!!gamedDescription">
         <a href="#"  :class="getCss('copy_text_style')" @click="showGameDescription" >产品功能</a>
        <span :class="getCss('copy_text_style')">|</span>
        </template>
      <a href="#"  :class="getCss('copy_text_style')" @click="handleOpenPrivate">隐私政策</a>
        <span :class="getCss('copy_text_style')">|</span>
      <a
        :class="getCss('copy_text_style')"
        href="#"
        @click="handleOpenPermission"
      >应用权限</a>
    </span>

    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CCopyright',
  mixins: [componentBaseMixin],
  props: {
    initDataFromProp: {
      type: Boolean,
      default: false,
    },
    fourElementInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cssPrefix: 'copyright-',
      // vue
      init: false,
      pageConfig: {},
      gameConfig: {
        developer: '深圳腾讯科技有限公司',
        gameName: '游戏名',
        version: '版本号',
        carrier: '深圳腾讯科技有限公司',
        privacyUrl: '',
        permissionUrl: '',
        description: '', //  游戏描述
      },
    };
  },
  computed: {
    showCopyRight() {
      return this.$isInEditor || this.init;
    },
    gamedDescription() {
      const { description = '' } = this.gameConfig;
      return description;
    },
    copyrightContainerStyle() {
      const { backgroundColor  = '#000000', color = '#ffffff', opacity = '0.55' } = this.configurationData || {};
      return {
        color: this.makeRgbaFunc(color, opacity),
        background: this.makeRgbaFunc(backgroundColor, opacity),
        ...this.styles.base,
        display: 'flex',
        padding: '0 0.24rem',
      };
    },
    isIOS() {
      return this.$platform.isIos;
    },
  },
  watch: {
    fourElementInfo: {
      handler(elementInfo) {
        console.log('elementInfo =', elementInfo);
        if (typeof  elementInfo === 'object' &&  elementInfo.developer) {
          this.init = true;
          this.gameConfig = elementInfo;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    console.log('configurationData= copy', this.configurationData);
    this.initialize();
  },
  methods: {
    showGameDescription() {
      if (this.gamedDescription) {
        this.$alert({ msg: `<span
        style="color: #17233d;font-size: 0.28rem;letter-spacing: 0.04rem;font-weight: 500;line-height: 1.5;
        font-family: 'PingFang SC';">
        ${this.gamedDescription}</span>` });
      }
    },
    makeRgbaFunc(color, opacity) {
      // eslint-disable-next-line no-eval
      return  `rgba(${parseInt(eval(`0x${color?.slice(1, 3)}`), 10)},${parseInt(eval(`0x${color?.slice(3, 5)}`), 10)},${parseInt(eval(`0x${color?.slice(5, 7)}`), 10)},${opacity})`;
    },
    initialize() {
      if (this.$isInEditor) return;
      this.initCopyrightGameConfig();
    },
    async initCopyrightGameConfig() {
      const { gid } = this.configurationData;
      if (this.isIOS || gid <= 0) {
        console.warn('download not setting gid or ios device', gid);
        return;
      }
      if (this.initDataFromProp) {
        console.log('initDataFromProp from copy ', this.initDataFromProp);
        return ;
      }
      const url = 'https://agw.xinyue.qq.com/api/tgclub/queryGameAddress';
      const response = await this.$axiosInstance.get(`${url}?gid=${gid}`);
      console.log('response queryGameAddress ', response);
      const { ret, data = {} } = response;
      const { ret: resRet } = data;
      if (ret !== 0 || resRet !== 0) {
        return  this.$alert({ msg: '系统繁忙，请刷新页面重试' });
      }
      const {  version, game_name: gameName,
        carrier, developer, privacy_url: privacyUrl,
        permission_url: permissionUrl, description } = data.GameInfos || {};
      console.log('response queryGameAddress and  data.gameInfos = ', data.gameInfos);
      // ###   四要素数据
      this.gameConfig = {
        privacyUrl,
        permissionUrl,
        developer,
        carrier,
        version,
        gameName,
        description,
      };
      this.init = true;
      return true;
    },
    handleOpenPrivate(event) {
      event && event.stopPropagation();
      let   { privacyUrl } =  this.gameConfig;
      privacyUrl = privacyUrl ||  'https://game.qq.com/privacy_guide.shtml';
      this.$ast.openView({ url: privacyUrl });
    },
    handleOpenPermission(event) {
      event && event.stopPropagation();
      const { permissionUrl } =  this.gameConfig;
      const url = permissionUrl
        || `https://xinyue.qq.com/act/a20210318common/app-authority.html?gid=${this.configurationData.gid}`;
      this.$ast.openView({
        url,
      });
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
